import React from 'react'
import PlusIcon from 'client/utils/icons/plus-icon'
import {
  DcButton,
  DcDiv,
  DcInput,
  DcSwitch,
  DcText,
  PixelFactoryContext,
  PixelFlexBox,
} from 'pixel-base'

import { handleAddRider } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'
const AddRiderForm = (props) => {
  const { courier_id, handleClose } = props
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [data, setData] = React.useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    prefix: '',
    address: '',
    active: 0,
  })
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const handleSubmit = (e) => {
    e.preventDefault()
    showPageLoader()

    handleAddRider(data, courier_id).subscribe((res: any) => {
      if (res.response.data) {
        showSuccess('Successfully Added')

        handleClose(res.response.data)
        hidePageLoader()
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
        hidePageLoader()
      }
    })
  }

  function formatVariableName(input: string): string {
    // Split the string by underscore, capitalize each word, and join with spaces
    return input
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
  }
  return (
    <>
      <form
        style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
        onSubmit={handleSubmit}
      >
        <PixelFlexBox
          flexWrap="wrap"
          gap="10px"
          width="100%"
          style={{ flexGrow: '1' }}
          flexDirection="row"
        >
          {Object.keys(data).map((key, index) => {
            return (
              <React.Fragment key={index}>
                {key === 'active' ? (
                  <div>
                    <DcSwitch
                      // className={"large"}
                      onChange={(e) => {
                        setData({ ...data, [key]: e.target.checked ? 1 : 0 })
                      }}
                      checked={data[key]}
                      label={data[key] ? 'Active' : 'Inactive'}
                    />
                  </div>
                ) : (
                  <DcDiv
                    width={
                      index == 0 || index == 1 || index == 2 || index == 3
                        ? '49%'
                        : '100%'
                    }
                    height="auto"
                    style={{
                      display: 'flex',

                      flexDirection: 'column',
                      alignItems: 'flexStart',
                    }}
                  >
                    <DcText
                      style={{
                        textAlign: 'left',

                        color: '#2e314a',
                        fontSize: '.875rem',
                        fontWeight: '500',
                        marginBottom: '.5rem',
                      }}
                    >
                      {formatVariableName(key)}
                    </DcText>
                    <DcInput
                      as={key === 'address' && 'textarea'}
                      className={key === 'phone' ? 'phone-input' : 'input'}
                      error={
                        error.field === key && error.error !== ''
                          ? error.error
                          : null
                      }
                      required
                      type={'text'}
                      name={key}
                      placeholder={key.replace(/_/g, ' ')}
                      value={data[key]}
                      onChange={(e) => {
                        setData({
                          ...data,
                          [key]: e.target.value,
                        })
                      }}
                    />
                  </DcDiv>
                )}
              </React.Fragment>
            )
          })}
        </PixelFlexBox>
        <PixelFlexBox
          flexWrap="wrap"
          justifyContent="flex-end"
          gap="10px"
          width="100%"
          flexDirection="row"
          flexEnd
        >
          <DcButton type={'submit'} size="sm" withIcon={true}>
            <PlusIcon size={16} />
            <span>Add</span>
          </DcButton>
        </PixelFlexBox>
      </form>
    </>
  )
}

export default AddRiderForm
